import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_125: FaireProductEntity = {
  token: "legacy_prod_abbott-125",
  type: "product",
  name: "Bell Shaped Cloche-6 H",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/6438e6a9c2af2be858c8be55bd360b18f79ab79d2709547254e6050b774d2044.jpeg",
  priceDollars: 32,
  subcategory: "Serveware",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_kitchen-tabletop"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
